import {apiBindings} from "../../utils/constants";
import {useIntegrator} from "../../integrator.context";
import {RemoveFileArchiveCommand} from "../../commands/removeFileArchive.command";
import SoundAsset from "../../elements/soundAsset";
import IconButton from "../../elements/IconButton";
import {useApp} from "../../app.context";

function ArchiveView() {
    const {state, executeCommand} = useIntegrator();
    const {confirmDelete} = useApp();

    function getFileType(fileName: string): string {
        return fileName.split('.')[1];
    }

    return (
        <div className={'layout vertical'} style={{gap: 10, flexGrow: 1}}>
            <div className={'layout horizontal gap'} style={{flexWrap: 'wrap', alignContent: 'flex-start', gap: 10, flexGrow: 1, overflow: 'auto', height: 0}}>
                {state.archive !== undefined && state.archive.map((file, index) => {
                    const url = `${apiBindings.images}${file.fileName}`;
                    const type = getFileType(file.fileName);
                    return (
                        <div key={index} style={{
                            position: 'relative',
                            width: 200, height: 200,
                            backgroundColor: 'var(--box-color)',
                            borderRadius: 'var(--border-radius)'
                        }}>
                            {type === 'png' && <div className={'layout vertical center'} style={{
                                position: 'absolute',
                                width: '100%',
                                height: '100%'
                            }}>
                                <img alt={file.fileName} style={{
                                    width: '150px'
                                }}
                                     src={url}
                                />
                                <p>{file.key}</p>
                            </div>}
                            <div style={{
                                position: 'absolute',
                                borderRadius: 'var(--border-radius)',
                                width: '100%',
                                height: '100%'
                            }}>
                                <div className={'layout horizontal gap'} style={{padding: 5}}>
                                    <IconButton icon={'fa-solid fa-trash'} onClick={async (e) => {
                                        e.stopPropagation();
                                        if (await confirmDelete(file.fileName, 'archive file'))
                                            executeCommand(new RemoveFileArchiveCommand(file.fileName));
                                    }}/>
                                    <IconButton icon={'fa-solid fa-download'} onClick={(e) => {
                                        e.stopPropagation();
                                        window.open(url);
                                    }}/>
                                </div>
                            </div>
                            {type === 'wav' && <div className={'layout vertical center gap'} style={{
                                position: 'absolute',
                                margin: 50,
                            }}>
                                <SoundAsset id={file.fileName} size={100} upload={false}/>
                                <p>{file.key}</p>
                            </div>}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ArchiveView;